class Monitoring.Models.SearchQuery extends Backbone.Model

  defaults: ->
    return {
      search_query_changed: false
      order: {
        field: 'date',
        direction: 'desc'
      }
      offset: 0
      number_of_results: 10
      tags: []
      tags_node_name: []
      only_tags_of_node_name: []
      primary_tags: []
      secondary_tags: []
      excluded_tags: []
      primary_tags_logic: 'OR'
      secondary_tags_logic: 'OR'
      excluded_tags_logic: 'OR'
      primary_labels: []
      secondary_labels: []
      excluded_labels: []
      primary_labels_logic: 'OR'
      secondary_labels_logic: 'OR'
      excluded_labels_logic: 'OR'
      labels: []
      locations: []
      texts: []
      text_exclusions: []
      texts_logic: 'OR'
      primary_keywords: []
      secondary_keywords: []
      excluded_keywords: []
      primary_keywords_logic: 'OR'
      secondary_keywords_logic: 'OR'
      excluded_keywords_logic: 'OR'
      moderators: []
      users: []
      general_users: []
      general_users_mode: 'include'
      type: []
      post_type: []
      sub_type: []
      title: []
      social_network_id: []
      hashtags: []
      hastags_logic: 'OR'
      mentions: []
      mentions_logic: 'OR'
      languages: []
      discovered_topics_ids: []
      discovered_topics_ids_logic: 'OR'
      related_discovered_topics_ids: []
      related_discovered_topics_ids_logic: 'OR'
      review_status: []
      content_id: undefined
      excluded_content_ids: []
      parent_post_id: undefined
      page_id: undefined
      immediate_parent_id: undefined
      context_kind: undefined
      context_limit: undefined
      manual_moderation: false
      klout_score: false
      include_page_owner_generated: false
      exclude_page_owner_generated: false
      influencer_list: false
      date_from_realtime: undefined
      date_from: undefined
      date_from_ISO: undefined
      date_to: undefined
      date_to_ISO: undefined
      date_now: false
      moderation_date_from_realtime: undefined
      moderation_date_from: undefined
      moderation_date_from_ISO: undefined
      moderation_date_to: undefined
      moderation_date_to_ISO: undefined
      moderation_date_now: false
      enhanced_gender: []
      geolocation: undefined
      sentiment: []
      countries: []
      status: []
      charts: @defaultCharts()
      custom_facets: {}
      custom_texts: {}
      review_from_analysis: false
      fb_posts: []
      twitter_posts: []
      instagram_posts: []
      tiktok_posts: []
      linkedin_posts: []
      youtube_posts: []
      channels: []
      min_followers: undefined
      max_followers: undefined
      post_from: undefined
      post_from_ISO: undefined
      post_to: undefined
      post_to_ISO: undefined
      post_now: false
      all_posts_active: false
      per_post_active: false
      post_primary_keywords: []
      post_secondary_keywords: []
      post_excluded_keywords: []
      post_primary_keywords_logic: 'OR'
      post_secondary_keywords_logic: 'OR'
      post_excluded_keywords_logic: 'OR'
      post_primary_tags: []
      post_secondary_tags: []
      post_excluded_tags: []
      post_primary_tags_logic: 'OR'
      post_secondary_tags_logic: 'OR'
      post_excluded_tags_logic: 'OR'
      post_texts: []
      post_text_exclusions: []
      post_mentions: []
      post_hashtags: []
      post_tags: []
      post_labels: []
      post_source: []
      post_source_type: []
      post_sub_type: []
      post_facebook_type: []
      post_fb_is_published: undefined
      not: {}
      child_comments_for: undefined
      chart_report_title: 'Dashboard Charts Report'
      include_twitter_replies: false
      exclude_twitter_replies: false
      post_include_twitter_replies: false
      post_exclude_twitter_replies: false
      include_facebook_replies: false
      exclude_facebook_replies: false
      fb_is_published: undefined
      is_instagram_ad: undefined
      fb_parent_post_is_published: undefined
      fb_parent_comment_id: undefined
      generic_user_filter: false
      emotion: undefined
      with_customer_tickets: undefined
      cem_surveys: []
      survey_sent_at_from_realtime: undefined
      survey_sent_at_from: undefined
      survey_sent_at_from_ISO: undefined
      survey_sent_at_to: undefined
      survey_sent_at_to_ISO: undefined
      survey_sent_at_now: false
      star_ratings: [],
      gmb_countries: [],
      gmb_provinces: [],
      gmb_cities: [],
      gmb_addresses: [],
      peakpeek_selected_provider: undefined,
      peakpeek_mode: false,
      assistant_explorer_id: null
    }

  constructor: (attributes, options) ->
    @use_defaults = true
    @defaultChartsByAccount = options.defaultCharts
    @moderator = options.moderator
    if options and options.use_defaults != undefined
      @use_defaults = options.use_defaults
    Backbone.Model.apply(this, arguments)

  initialize: ->
    if @use_defaults
      current_day = I18n.t('monitoring.dashboard.filters.filter_names.time.day', {count: 0})
      @set('date_from_realtime', {value: 'current_day', name: current_day}) unless @get('analysisMode')
      post_from = new Date()
      post_from.setDate(post_from.getDate() - 7)
      post_from.setHours(0, 0, 0, 0)
      @set('post_from', @_formatDate(post_from))
      @set('post_from_ISO', post_from.toISOString())
      post_to = new Date()
      post_to.setDate(post_to.getDate() + 1)
      post_to.setHours(0, 0, 0, 0)
      @set('post_to', @_formatDate(post_to))
      @set('post_to_ISO', post_to.toISOString())
      @set('post_now', true)
      if @get('reviewMode')
        last_three_months = "#{I18n.t('monitoring.dashboard.filters.filter_names.time.current.last_m.other')} #{I18n.t('monitoring.dashboard.filters.filter_names.time.three')} #{I18n.t('monitoring.dashboard.filters.filter_names.time.month.other')}"
        @set('date_from_realtime', {value: '129600', name: last_three_months})
        @set('status', ['UNKNOWN'])
        @set('review_status', ['NOT_REVIEWED'])
    if @moderator
      @set('date_from_realtime', undefined)
      @addModerator(@moderator)
      @addReviewStatus('REVIEWED')

  next: (numberOfResults) ->
    @set('number_of_results', numberOfResults)

  complete: ->
    @set('offset', @get('number_of_results') + @get('offset'))

  resetCounter: ->
    @set('offset', @defaults().offset)
    @set('number_of_results', @defaults().number_of_results)

  resetField: (name) ->
    console.log("#{name} doesnt't exist") unless @defaults().hasOwnProperty(name)
    @set(name, @defaults()[name])

  reset: ->
    charts = @get('charts')
    channels = @get('channels')
    fb_posts = @get('fb_posts')
    twitter_posts = @get('twitter_posts')
    review_status = @get('review_status')
    @set(@defaults())
    @set('charts', charts)
    @set('channels', channels)
    @set('fb_posts', fb_posts)
    @set('twitter_posts', twitter_posts)
    @set('review_status', review_status) if @get('reviewMode')

  setOrderField: (field) ->
    @set('order', { field: field, direction: @get('order').direction })

  setOrderDirection: (direction) ->
    @set('order', { field: @get('order').field, direction: direction })

  addValueToField: (field, value) ->
    if @get(field).indexOf(value) == -1
      @get(field).push(value)

  removeValueFromField: (field, value) ->
    if (index = @get(field).indexOf(value)) != -1
      @get(field).splice(index, 1)

  addLocation: (location) ->
    @addValueToField('locations', location)

  removeLocation: (location)  ->
    @removeValueFromField('locations', location)

  addGender: (gender) ->
    @addValueToField('enhanced_gender', gender)

  removeGender: (gender) ->
    @removeValueFromField('enhanced_gender', gender)

  addDiscoveredTopicsIds: (topicId) ->
    @addValueToField('discovered_topics_ids', topicId)

  removeDiscoveredTopicsIds: (topicId) ->
    @removeValueFromField('discovered_topics_ids', topicId)

  removeTopic: (topic) ->
    @removeValueFromField('topics', topic)

  getAllTexts: ->
    _.union(@get('texts'), @get('text_exclusions'), @get('post_texts'), @get('post_text_exclusions'))

  getAllTags: ->
    _.union(@get('tags'), @get('primary_tags'), @get('secondary_tags'), @get('excluded_tags'), @get('post_tags'))

  addTag: (tag) ->
    @addValueToField('tags', tag)

  addPrimaryTag: (tag) ->
    @addValueToField('primary_tags', tag)

  addSecondaryTag: (tag) ->
    @addValueToField('secondary_tags', tag)

  addExcludedTag: (tag) ->
    @addValueToField('excluded_tags', tag)

  addPostTag: (tag) ->
    @addValueToField('post_tags', tag)

  removePrimaryTag: (tag) ->
    @removeValueFromField('primary_tags', tag)

  removeSecondaryTag: (tag)  ->
    @removeValueFromField('secondary_tags', tag)

  removeTag: (tag)  ->
    @removeValueFromField('tags', tag)

  removeExcludedTag: (tag)  ->
    @removeValueFromField('excluded_tags', tag)

  removePostTag: (tag)  ->
    @removeValueFromField('post_tags', tag)

  removePostPrimaryTag: (tag)  ->
    @removeValueFromField('post_primary_tags', tag)

  removePostSecondaryTag: (tag)  ->
    @removeValueFromField('post_secondary_tags', tag)

  removePostExcludedTag: (tag)  ->
    @removeValueFromField('post_excluded_tags', tag)

  removePrimaryKeyword: (keyword)  ->
    @removeValueFromField('primary_keywords', keyword)

  removeSecondaryKeyword: (keyword)  ->
    @removeValueFromField('secondary_keywords', keyword)

  removeExcludedKeyword: (keyword)  ->
    @removeValueFromField('excluded_keywords', keyword)

  removePostPrimaryKeyword: (keyword)  ->
    @removeValueFromField('post_primary_keywords', keyword)

  removePostSecondaryKeyword: (keyword)  ->
    @removeValueFromField('post_secondary_keywords', keyword)

  removePostExcludedKeyword: (keyword)  ->
    @removeValueFromField('post_excluded_keywords', keyword)

  addLanguage: (language) ->
    @addValueToField('languages', language)

  removeLanguage: (language) ->
    @removeValueFromField('languages', language)

  setReviewStatus: (reviewStatuses) ->
    @set('review_status', reviewStatuses)

  addReviewStatus: (reviewStatus) ->
    @addValueToField('review_status', reviewStatus)

  removeReviewStatus: (reviewStatus)  ->
    @removeValueFromField('review_status', reviewStatus)

  addContentId: (value) ->
    @set('content_id', value)

  removeContentId: ->
    @set('content_id', undefined)

  addExcludedContentId: (contentId) ->
    # @set('not.content_id', contentId)
    @get('not').content_id = contentId

  addPageId: (value) ->
    @set('page_id', value)

  removePageId: (value) ->
    @set('page_id', undefined)

  addParentPostId: (value) ->
    @set('parent_post_id', value)

  removeParentPostId: ->
    @set('parent_post_id', undefined)

  addImmediateParentId: (value) ->
    @set('immediate_parent_id', value)

  removeImmediateParentId: ->
    @set('immediate_parent_id', undefined)

  getContextKind: ->
    @get('context_kind')

  addContextKind: (value) ->
    @set('context_kind', value)

  removeContextKind: ->
    @set('context_kind', undefined)

  getChildCommentsFor:->
    @get('child_comments_for')

  addChildCommentsFor: (value)->
    @set('child_comments_for', value)

  removeChildCommentsFor:->
    @set('child_comments_for', undefined)

  getParentId:->
    @get('parent_id')

  addParentId: (value)->
    @set('parent_id', value)

  removeParentId:->
    @set('parent_id', undefined)

  getGMBParentReviewId: ->
    @get('gmb_parent_review_id')

  addGMBParentReviewId: (value) ->
    @set('gmb_parent_review_id', value)

  removeGMBParentReviewId: ->
    @set('gmb_parent_review_id', undefined)

  getContextLimit: ->
    @get('context_limit')

  addContextLimit: (value) ->
    @set('context_limit', value)

  removeContextLimit: ->
    @set('context_kind', undefined)

  removePrimaryLabel: (label) ->
    @removeValueFromField('primary_labels', label)

  removeSecondaryLabel: (label)  ->
    @removeValueFromField('secondary_labels', label)

  removeExcludedLabel: (label)  ->
    @removeValueFromField('excluded_labels', label)

  addLabel: (label) ->
    @addValueToField('labels', label)

  addPostLabel: (label) ->
    @addValueToField('post_labels', label)

  removeLabel: (label)  ->
    @removeValueFromField('labels', label)

  removePostLabel: (label)  ->
    @removeValueFromField('post_labels', label)

  removeAllLabels: ->
    @set('labels', [])

  addText: (text, inclusionLogic) ->
    if inclusionLogic and (@get('texts').indexOf(text)) == -1
      @get('texts').push(text)
    else if not inclusionLogic and (@get('text_exclusions').indexOf(text)) == -1
      @get('text_exclusions').push(text)

  addPostText: (text, inclusionLogic) ->
    if inclusionLogic and (@get('post_texts').indexOf(text)) == -1
      @get('post_texts').push(text)
    else if not inclusionLogic and (@get('post_text_exclusions').indexOf(text)) == -1
      @get('post_text_exclusions').push(text)

  removeText: (text) ->
    if (index = @get('texts').indexOf(text)) != -1
      @get('texts').splice(index, 1);
    else if (index_ = @get('text_exclusions').indexOf(text)) != -1
      @get('text_exclusions').splice(index_, 1);

  removePostText: (text) ->
    if (index = @get('post_texts').indexOf(text)) != -1
      @get('post_texts').splice(index, 1);
    else if (index_ = @get('post_text_exclusions').indexOf(text)) != -1
      @get('post_text_exclusions').splice(index_, 1);

  addModerator: (moderator) ->
    @addValueToField('moderators', moderator)

  removeModerator: (moderator) ->
    @removeValueFromField('moderators', moderator)

  setManualModeration: (bool) ->
    @set('manual_moderation', bool)

  addUser: (user) ->
    @addValueToField('users', user)

  removeUser: (user) ->
    @removeValueFromField('users', user)

  addGeneralUser: (user) ->
    user = user.substr(1) if user[0] == '@'
    return unless user.length > 0
    @addValueToField('general_users', user)

  removeGeneralUser: (user) ->
    @removeValueFromField('general_users', user)

  addStatus: (status) ->
    @addValueToField('status', status)

  removeStatus: (status) ->
    @removeValueFromField('status', status)

  removeStarRatings: (star_ratings) ->
    @removeValueFromField('star_ratings', star_ratings)

  removeGmbCountry: (country) ->
    @removeValueFromField('gmb_countries', country)

  removeGmbProvince: (province) ->
    @removeValueFromField('gmb_provinces', province)

  removeGmbCity: (city) ->
    @removeValueFromField('gmb_cities', city)

  removeGmbAddress: (address) ->
    @removeValueFromField('gmb_addresses', address)

  addType: (type) ->
    @addValueToField('type', type)

  removeType: (type) ->
    @removeValueFromField('type', type)

  addPostType: (post_type) ->
    @addValueToField('post_type', post_type)

  addPostFacebookType: (type) ->
    @addValueToField('post_facebook_type', type)

  removePostFacebookType: (type) ->
    @removeValueFromField('post_facebook_type', type)

  removePostType: (post_type) ->
    @removeValueFromField('post_type', post_type)

  addPostSource: (post_source) ->
    @addValueToField('post_source', post_source)

  removePostSource: (post_source) ->
    @removeValueFromField('post_source', post_source)

  addPostSourceType: (post_source_type) ->
    @addValueToField('post_source_type', post_source_type)

  removePostSourceType: (post_source_type) ->
    @removeValueFromField('post_source_type', post_source_type)

  addTitle: (title) ->
    @addValueToField('title', title)

  removeTitle: (title) ->
    @removeValueFromField('title', title)

  addSocialNetworkId: (hash) ->
    @addValueToField('social_network_id', hash)

  removeSocialNetworkId: (socialNetworkId) ->
    element = _.find(@get('social_network_id'), (element) ->
      element.value == socialNetworkId)

    if element
      index = @get('social_network_id').indexOf(element)
      @get('social_network_id').splice(index, 1);

  setStarRatings: (starRatings) ->
    @set('star_ratings', starRatings)

  setGmbCountries: (countries) ->
    @set('gmb_countries', countries)

  setGmbProvinces: (provinces) ->
    @set('gmb_provinces', provinces)

  setGmbCities: (cities) ->
    @set('gmb_cities', cities)

  setGmbAddresses: (addresses) ->
    @set('gmb_addresses', addresses)

  addSubtype: (subtype) ->
    @addValueToField('sub_type', subtype)

  removeSubtype: (subtype) ->
    @removeValueFromField('sub_type', subtype)

  addCustomFacet: (name, value) ->
    customFacets = @get('custom_facets')
    customFacets[name] ||= []
    if (customFacets[name].indexOf(value)) == -1
      customFacets[name].push(value)

  removeCustomFacet: (name, value) ->
    customFacets = @get('custom_facets')
    customFacets[name] ||= []
    if (index = customFacets[name].indexOf(value)) != -1
      customFacets[name].splice(index, 1);

  addCustomText: (name, value) ->
    customTexts = @get('custom_texts')
    customTexts[name] ||= []
    if (customTexts[name].indexOf(value)) == -1
      customTexts[name].push(value)

  removeCustomText: (name, value) ->
    customTexts = @get('custom_texts')
    customTexts[name] ||= []
    if (index = customTexts[name].indexOf(value)) != -1
      customTexts[name].splice(index, 1);

  setIncludeReplies: (included, source) ->
    @set("include_#{source}_replies", included)

  setExcludeReplies: (included, source) ->
    @set("exclude_#{source}_replies", included)

  setPostIncludeReplies: (included, source) ->
    @set("post_include_#{source}_replies", included)

  setPostExcludeReplies: (excluded, source) ->
    @set("post_exclude_#{source}_replies", excluded)

  setFbIsPublished: (isPublished) ->
    @set('fb_is_published', isPublished)

  setIgIsPromoted: (isPromoted) ->
    @set('is_instagram_ad', isPromoted)

  setWithCustomerTickets: (hasTickets) ->
    @set('with_customer_tickets', hasTickets)

  setPostFbIsPublished: (isPublished) ->
    @set('post_fb_is_published', isPublished)

  setParentPostIsPublished: (isFromPublished) ->
    @set('fb_parent_post_is_published', isFromPublished)

  setParentCommentId: (parentCommentId) ->
    @set('fb_parent_comment_id', parentCommentId)

  setFilterByKlout: (isChecked) ->
    @set('klout_score', isChecked)

  setFilterByInfluencerList: (isChecked) ->
    @set('influencer_list', isChecked)

  addMention: (mention) ->
    @addValueToField('mentions', mention)

  addPostMention: (mention) ->
    @addValueToField('post_mentions', mention)

  removeMention: (mention) ->
    @removeValueFromField('mentions', mention)

  removePostMention: (mention) ->
    @removeValueFromField('post_mentions', mention)

  addHashtag: (hashtag) ->
    @addValueToField('hashtags', hashtag)

  addPostHashtag: (hashtag) ->
    @addValueToField('post_hashtags', hashtag)

  removeHashtag: (hashtag) ->
    @removeValueFromField('hashtags', hashtag)

  removePostHashtag: (hashtag) ->
    @removeValueFromField('post_hashtags', hashtag)

  addDateFromRealtime: (value, name, prefix = 'date') ->
    @set("#{prefix}_from_realtime", {value: value, name: name})

  addModerationDateFromRealtime: (value) ->
    @set('moderation_date_from_realtime', value)

  removeDateFromRealtime: (prefix = 'date') ->
    @set(prefix + '_from_realtime', undefined)

  removeModerationDateFromRealtime: ->
    @set('moderation_date_from_realtime', undefined)

  addDateFrom: (dateFrom, format = 'D MMM YYYY HH:mm', prefix = 'date') ->
    from = @_parseDate(dateFrom, format)
    @set("#{prefix}_from", from.format(format))
    @set("#{prefix}_from_ISO", from.toISOString())

  addModerationDateFrom: (dateFrom, format="D MMM YY HH:mm", prefix = 'moderation_date') ->
    from = @_parseDate(dateFrom, format)
    @set("#{prefix}_from", from.format(format))
    @set("#{prefix}_from_ISO", from.toISOString())

  addPostDateFrom: (dateFrom) ->
    from = @_parseDate(dateFrom)
    @set('post_from', @_formatDate(from))
    @set('post_from_ISO', from.toISOString())

  removeDateFrom: (prefix = 'date') ->
    @set("#{prefix}_from", undefined)
    @set("#{prefix}_from_ISO", undefined)

  removeModerationDateFrom: ->
    @set('moderation_date_from', undefined)
    @set('moderation_date_from_ISO', undefined)

  removePostDateFrom: ->
    @set('post_from', undefined)
    @set('post_from_ISO', undefined)

  addDateTo: (dateTo, format = 'D MMM YYYY HH:mm', prefix = 'date') ->
    to = @_parseDate(dateTo)
    @setNowDate(false, prefix)
    @set("#{prefix}_to", to.format(format))
    @set("#{prefix}_to_ISO", to.toISOString())

  addModerationDateTo: (dateTo, format = 'D MMM YYYY HH:mm', prefix = 'moderation_date') ->
    to = @_parseDate(dateTo)
    @setModerationNowDate(false)
    @set("#{prefix}_to", to.format(format))
    @set("#{prefix}_to_ISO", to.toISOString())

  addPostDateTo: (dateTo) ->
    to = @_parseDate(dateTo)
    @setNowDate(false)
    @set('post_to', @_formatDate(to))
    @set('post_to_ISO', to.toISOString())

  removeDateTo: (prefix = 'date') ->
    @set("#{prefix}_to", undefined)
    @set("#{prefix}_now", false)
    @set("#{prefix}_to_ISO", undefined)

  removeModerationDateTo: ->
    @set('moderation_date_to', undefined)
    @set('moderation_date_now', false)
    @set('moderation_date_to_ISO', undefined)

  removePostDateTo: ->
    @set('post_to', undefined)
    @set('post_now', false)
    @set('post_to_ISO', undefined)

  setNowDate: (isChecked, prefix = 'date') ->
    @set("#{prefix}_now", isChecked)

  setModerationNowDate: (isChecked, prefix = 'moderation_date') ->
    @set("#{prefix}_now", isChecked)

  setPostNowDate: (isChecked) ->
    @set('post_now', isChecked)

  addSentiment: (sentiment) ->
    @addValueToField('sentiment', sentiment)

  removeSentiment: (sentiment) ->
    @removeValueFromField('sentiment', sentiment)

  addCountry: (country) ->
    @addValueToField('countries', country)

  removeCountry: (country) ->
    @removeValueFromField('countries', country)

  setGeolocation: (geolocation) ->
    @set('geolocation', geolocation)

  removeGeolocation: ->
    @set('geolocation', undefined)

  removeTagsNodeName: (node_name) ->
    @removeValueFromField('tags_node_name', node_name)

  removeOnlyTagsOfNodeName: (node_name) ->
    @removeValueFromField('only_tags_of_node_name', node_name)

  addSurveyItem: (code, alias, value, surveyName, surveyId) ->
    cemSurveys = new Monitoring.Models.SurveyCollection(@get('cem_surveys'))
    survey = cemSurveys.findOrCreate(surveyName, surveyId)
    survey.addItem(code, value, alias)
    @set('cem_surveys', cemSurveys.toJSON())

  removeSurveyItem: (code, value, surveyId) ->
    cemSurveys = new Monitoring.Models.SurveyCollection(@get('cem_surveys'))
    survey = cemSurveys.findById(surveyId)
    survey.removeItem(code, value)
    @set('cem_surveys', cemSurveys.toJSON())

  getSurveyKeywords: (attribute, code, survey) ->
    cemSurveys = new Monitoring.Models.SurveyCollection(@get('cem_surveys'))
    searchSurvey = cemSurveys.findById(survey.id)
    if searchSurvey
      attributeValue = searchSurvey.getKeyword(code, attribute)
    else
      attributeValue = Monitoring.Models.Survey.keywordDefaults[attribute]
    return attributeValue

  setSurveyKeywords: (attribute, value, itemCode, survey) ->
    cemSurveys = new Monitoring.Models.SurveyCollection(@get('cem_surveys'))
    searchSurvey = cemSurveys.findOrCreate(survey.name, survey.id)
    searchSurvey.setKeyword(itemCode, attribute, value)
    @set('cem_surveys', cemSurveys.toJSON())

  removeSurveyKeyword: (attribute, value, itemCode, survey) ->
    cemSurveys = new Monitoring.Models.SurveyCollection(@get('cem_surveys'))
    searchSurvey = cemSurveys.findById(survey.id)
    searchSurvey.removeKeyword(itemCode, attribute, value)
    @set('cem_surveys', cemSurveys.toJSON())

  resetSurveyKeyword: (code, survey)->
    cemSurveys = new Monitoring.Models.SurveyCollection(@get('cem_surveys'))
    searchSurvey = cemSurveys.findById(survey.id)
    searchSurvey.resetKeywords(code)
    @set('cem_surveys', cemSurveys.toJSON())

  deepCopy: ->
    newQuery = new Monitoring.Models.SearchQuery({}, {use_defaults: false, defaultCharts: @defaultChartsByAccount})
    return $.extend(true, newQuery, this);

  hasEspecificTime: (prefix = 'date') ->
    @get("#{prefix}_from") && (@get("#{prefix}_to") || @get("#{prefix}_now"))

  hasEspecificModerationTime: ->
    @get('moderation_date_from') && (@get('moderation_date_to') || @get('moderation_date_now'))

  hasEspecificPostTime: ->
    @get('post_from') && (@get('post_to') || @get('post_now'))

  _formatDate: (date) ->
    monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return "#{date.getDate()} #{monthNames[date.getMonth()]} #{date.getFullYear()} #{date.toTimeString().substring(0,5)}"

  _parseDate: (dateStr) ->
    Date.create(dateStr)

  defaultCharts: ->
    if @defaultChartsByAccount
      return @defaultChartsByAccount
    else
      return [
        { class: 'TweetsPerMinuteView' },
        { class: 'SentimentTimeseriesView' }
      ]

  changeState: (state_name, value) ->
    @set(state_name, value)
    # In analyis mode, is managed by view component itself.
    if !@get('analysisMode')
      $.ajax
        url: '/monitoring/dashboard/update_query',
        type: 'POST',
        data: @.toJSON()
#      success: () =>
#        console.log msg

  addChannel: (channel) ->
    @get('channels').push(channel)

  resetChannels: ->
    @set('channels', [])

  getNormalizedChannels: ->
    withDuplicates = _.map(@get('channels'), (c) ->
      if c.fb_id
        { provider: 'facebook', uid: c.fb_id, name: c.name, owner: c.owner }
      else
        { provider: c.provider, uid: c.uid, name: c.name, owner: c.owner }
    )
    _.uniq(withDuplicates, (c) -> c.provider + c.uid + c.name)

  selectedPosts:
    'facebook': 'fb_posts'
    'twitter': 'twitter_posts'
    'instagram': 'instagram_posts'
    'instagramMedia': 'instagram_posts'
    'tiktok': 'tiktok_posts'
    'linkedin': 'linkedin_posts'
    'youtube': 'youtube_posts'

  getKey: (type) ->
    @selectedPosts[type] || 'twitter_posts'

  getList: (type) ->
    @get(@getKey(type)) || @get('twitter_posts')

  addPost: (id, type) ->
    @set(@getKey(type), _.union(@getList(type), [id]))

  addPosts: (posts) ->
    _.each(posts, (post) => @addPost(post['id'], post['type']))

  removePost: (id, type) ->
    @set(@getKey(type), _.without(@getList(type), id))

  hasPost: (id, type) ->
    _.contains(@getList(type), id)

  resetPosts: ->
    @set(type, []) for type in _.values(@selectedPosts)

  postSelectionDone: ->
    !@get('analysisMode') or ((@get('per_post_active') or @get('all_posts_active')) && @hasSelectedPosts())

  getSelectedPosts: =>
    posts = []
    for k,v of @selectedPosts
      posts = posts.concat(@getList(k))
    posts

  hasSelectedPosts: ->
    for k,v of @selectedPosts
      return true if @getList(k).length > 0
    false

  setEmotion: (emotion) ->
    @set('emotion', emotion)
